export const FIND_PORTAL_PATH = '/find-portal';
export const PORTAL_ROUTER_LOOKUP_PATH = '/api/portal/router/lookup';

// Typed addresses, link shorteners and some email clients add a trailing slash, and the
// router is the page a borrower reaches by typing or from a bookmark.
export const isFindPortalPath = (pathname: string): boolean => pathname.replace(/\/+$/, '') === FIND_PORTAL_PATH;
